import { EntityComputeDefinitionApi } from '@apps/auth/api/models/back/entity-compute-definition-api';
import { DateTime } from 'luxon';

export class EntityComputeDefinition
{
    id?: string;
    entityId!: string;
    active?: boolean;
    createdAt?: DateTime;
    modifiedAt?: DateTime;

    vDomain?: string;

    computeVmwares: VmwareFilter[] = [];
    storages: StorageFilter[] = [];
    backups: MasterFilter[] = [];
    veeams: VeeamFilter[] = [];
    vbos: VboFilter[] = [];

    
    static mapperFromApi (computeDefinitionApi: EntityComputeDefinitionApi)
    {
        const entityComputeDefinition: EntityComputeDefinition = Object.assign(new EntityComputeDefinition(), computeDefinitionApi);

        return entityComputeDefinition;
    }
}

export class QueryDefinitionFilter {
    matchAllValues?: boolean;
}

export class QueryFilterValues extends QueryDefinitionFilter {
    values: string[] = [];
    isNegated?: boolean;

    constructor (values: string[], isNegated: boolean = false)
    {
        super();
        
        this.values = values;
        this.isNegated = isNegated;
    }

    static getValues (filterValues: QueryFilterValues): string
    {
        if (filterValues && filterValues.values)
        {
            return filterValues.values.join(',');
        }

        return '';
    }
}

export class MasterFilter extends QueryDefinitionFilter {
    masterName?: string;
    policyPrefix?: string;
}

export class VmwareFilter extends QueryDefinitionFilter {
    vcenters?: QueryFilterValues;
    path?: QueryFilterValues;
}

export class StorageDataName {
    volume?: QueryFilterValues;
    name?: QueryFilterValues;
}

export class StorageHost {
    volume?: QueryFilterValues;
    name?: QueryFilterValues;
}

export class StorageFilter extends QueryDefinitionFilter {
    name?: QueryFilterValues;
    datastoreUrlName?: QueryFilterValues;
    dataName?: StorageDataName;
    host?: StorageHost;
}

export class VeeamFilter extends QueryDefinitionFilter {
    hostName?: QueryFilterValues;
}

export class VboFilter extends QueryDefinitionFilter {
    hostName?: QueryFilterValues;
}
